import {gql} from 'apollo-angular';

export const GET_MY_DEPUTIES = gql`
  query myDeputies {
    myDeputies {
      id
      uuid
      email
      firstName
      lastName
    }
  }
`;
